import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { isNumericAndNot0 } from "@/core/string";

type CurrencyFormatProps = {
    value: string | number | null | undefined;
};

const CurrencyFormat: FC<CurrencyFormatProps> = ({ value }) => {
    const { i18n } = useTranslation();
    let locale = "en-BE";
    switch (i18n.language) {
        case "fr":
        case "de":
        case "en":
        case "nl":
            locale = `${i18n.language}-BE`;
            break;
    }
    return (
        <>
            {!isNumericAndNot0(value)
                ? "-"
                : new Intl.NumberFormat(locale, {
                      style: "currency",
                      currency: "EUR",
                      minimumFractionDigits: 2,
                  }).format(Number(value))}
        </>
    );
};

export default CurrencyFormat;
